import { render, staticRenderFns } from "./ModalCongrats.vue?vue&type=template&id=0bb772cd&"
import script from "./ModalCongrats.vue?vue&type=script&lang=js&"
export * from "./ModalCongrats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bb772cd')) {
      api.createRecord('0bb772cd', component.options)
    } else {
      api.reload('0bb772cd', component.options)
    }
    module.hot.accept("./ModalCongrats.vue?vue&type=template&id=0bb772cd&", function () {
      api.rerender('0bb772cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Configuration/App/Modal/ModalCongrats.vue"
export default component.exports